import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "container container-extra" }
const _hoisted_2 = { class: "flex justify-between h-16 space-x-2" }
const _hoisted_3 = { class: "items-center hidden space-x-3 lg:space-x-4 xl:space-x-10 navigation sm:-my-px md:flex md:ml-6 xl:ml-20" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Post a Remote Job ")
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Remote Recruiting ")
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Find a Remote Job ")
const _hoisted_10 = { class: "relative hidden md:block" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Browse ")
const _hoisted_12 = { class: "py-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Browse Remote Jobs ")
const _hoisted_14 = { class: "py-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Browse Candidates ")
const _hoisted_16 = { class: "py-1" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Browse Services ")
const _hoisted_18 = { class: "items-center justify-center hidden ml-2 md:flex" }
const _hoisted_19 = {
  key: 0,
  class: "relative hidden ml-3 outline-none md:block",
  tabindex: "0"
}
const _hoisted_20 = { class: "flex-row items-center space-x-2 lg:space-x-6" }
const _hoisted_21 = {
  key: 1,
  class: "flex flex-row items-center space-x-2 sm:space-x-6 md:space-x-2 lg:space-x-6"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Get Started ")
const _hoisted_23 = { class: "relative flex items-center -mr-2 space-x-4 md:hidden" }
const _hoisted_24 = {
  key: 0,
  class: "absolute z-40 flex items-center ml-2 text-xs font-medium text-white bg-red-400 border-2 border-white rounded-full top-2 -right-2 px-1.5 py-0.5"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Post a Remote Job ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Remote Recruiting ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Find a Remote Job ")
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Browse Jobs ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Browse Candidates ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Browse Services ")
const _hoisted_32 = { class: "pt-2 pb-3" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Get Started ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DJLogoShort = _resolveComponent("DJLogoShort")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_ProfileIcon = _resolveComponent("ProfileIcon")!
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("nav", _mergeProps(_ctx.$attrs, { class: "relative bg-white border-b border-gray-200 z-35" }), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          to: { name: 'home', query: _ctx.query },
          class: "flex items-center flex-shrink-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DJLogoShort, {
              class: "w-auto h-8 text-red-600 transition",
              alt: "Dynamite Jobs Logo"
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: { name: 'post-a-remote-job', query: _ctx.query },
              class: "text-xs font-medium leading-4 text-center text-gray-500 transition lg:leading-6 lg:text-sm hover:text-gray-900 focus:text-gray-900 focus:outline-none",
              "active-class": "!text-gray-900"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RouterLink, {
              to: { name: 'remote-recruiting', query: _ctx.query },
              class: "text-xs font-medium leading-4 text-center text-gray-500 transition lg:leading-6 lg:text-sm hover:text-gray-900 focus:text-gray-900 focus:outline-none",
              "active-class": "!text-gray-900"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_RouterLink, {
              to: { name: !_ctx.loggedIn ? 'how-to-find-remote-jobs' : 'candidate-pro', query: _ctx.query },
              class: "text-xs font-medium leading-4 text-center text-gray-500 transition lg:leading-6 lg:text-sm hover:text-gray-900 focus:text-gray-900 focus:outline-none",
              "active-class": "!text-gray-900"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Menu, {
              as: "div",
              class: "relative inline-block text-left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_MenuButton, { class: "flex items-center text-xs font-medium leading-4 text-center text-gray-500 transition lg:leading-6 lg:text-sm hover:text-gray-900 focus:text-gray-900 focus:outline-none" }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createVNode(_component_ChevronDownIcon, {
                        class: "w-5 h-5 ml-2 -mr-1",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition duration-100 ease-out",
                  "enter-from-class": "transform scale-95 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100",
                  "leave-active-class": "transition duration-75 ease-in",
                  "leave-from-class": "transform scale-100 opacity-100",
                  "leave-to-class": "transform scale-95 opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MenuItems, { class: "absolute w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg -left-4 ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_RouterLink, {
                                to: { name: 'jobs', query: _ctx.query },
                                class: "block px-4 py-2 text-xs font-medium leading-4 text-gray-500 transition lg:leading-6 lg:text-sm hover:text-gray-900 focus:text-gray-900 focus:outline-none",
                                "active-class": "!text-gray-900"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_RouterLink, {
                                to: { name: 'profiles', query: _ctx.query },
                                class: "block px-4 py-2 text-xs font-medium leading-4 text-gray-500 transition lg:leading-6 lg:text-sm hover:text-gray-900 focus:text-gray-900 focus:outline-none",
                                "active-class": "!text-gray-900"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_RouterLink, {
                                to: { name: 'services', query: _ctx.query },
                                class: "block px-4 py-2 text-xs font-medium leading-4 text-gray-500 transition text-centertext-xs lg:leading-6 lg:text-sm hover:text-gray-900 focus:text-gray-900 focus:outline-none",
                                "active-class": "!text-gray-900"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_17
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.totalNews)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "absolute top-0 z-40 flex items-center px-2 ml-2 text-xs font-medium text-white bg-red-400 border-2 border-white rounded-full cursor-pointer py-0.5 -right-2",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sidebar = !_ctx.sidebar))
                      }, _toDisplayString(_ctx.totalNews), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ProfileIcon, {
                    id: "user-menu",
                    icon: _ctx.myProfile?.icon,
                    element: "button",
                    inverse: false,
                    interactive: true,
                    uid: _ctx.myProfile?.id,
                    color: "gray",
                    size: "xs",
                    mode: "profile",
                    "aria-label": "User Menu",
                    "aria-haspopup": "true",
                    "admin-takover": !!_ctx.adminLoggedAs,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebar = !_ctx.sidebar))
                  }, null, 8, ["icon", "uid", "admin-takover"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'enter', query: _ctx.query },
                  class: "px-4 text-xs font-medium text-red-600 transition-colors duration-300 border border-red-600 rounded-md py-1.5 focus:outline-none hover:text-red-500 hover:border-red-400 focus:bg-red-100 active:text-white active:bg-red-600"
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            "aria-label": "Mobile Menu",
            class: "inline-flex items-center justify-center p-2 text-gray-400 transition rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleDropDown && _ctx.toggleDropDown(...args)))
          }, [
            _createVNode(_component_MenuIcon, {
              "aria-hidden": "true",
              class: _normalizeClass([{ hidden: _ctx.state.menuSettings, block: !_ctx.state.menuSettings }, "w-6 h-6"])
            }, null, 8, ["class"]),
            _createVNode(_component_XIcon, {
              "aria-hidden": "true",
              class: _normalizeClass(["w-6 h-6", { block: _ctx.state.menuSettings, hidden: !_ctx.state.menuSettings }])
            }, null, 8, ["class"])
          ]),
          (_ctx.totalNews)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.totalNews), 1))
            : _createCommentVNode("", true),
          (_ctx.loggedIn)
            ? (_openBlock(), _createBlock(_component_ProfileIcon, {
                key: 1,
                icon: _ctx.myProfile?.icon,
                element: "button",
                inverse: false,
                interactive: true,
                uid: _ctx.myProfile?.id,
                color: "gray",
                size: "xs",
                mode: "profile",
                class: "mr-4",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sidebar = !_ctx.sidebar))
              }, null, 8, ["icon", "uid"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["relative bg-white border-b md:hidden border-cool-gray-200", {
        'block': _ctx.state.menuSettings,
        'hidden': !_ctx.state.menuSettings,
      }])
    }, [
      _createVNode(_component_RouterLink, {
        to: { name: 'post-a-remote-job', query: _ctx.query },
        class: "block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition border-l-4 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50 focus:text-gray-800 focus:border-gray-300 focus:outline-none focus:bg-gray-50",
        "active-class": "!text-red-700 !border-red-500 !bg-red-50 !focus:text-red-800 !focus:bg-red-100 !focus:border-red-700 !focus:outline-none"
      }, {
        default: _withCtx(() => [
          _hoisted_25
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_RouterLink, {
        to: { name: 'remote-recruiting', query: _ctx.query },
        class: "block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition border-l-4 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50 focus:text-gray-800 focus:border-gray-300 focus:outline-none focus:bg-gray-50",
        "active-class": "!text-red-700 !border-red-500 !bg-red-50 !focus:text-red-800 !focus:bg-red-100 !focus:border-red-700 !focus:outline-none"
      }, {
        default: _withCtx(() => [
          _hoisted_26
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_RouterLink, {
        to: { name: !_ctx.loggedIn ? 'how-to-find-remote-jobs' : 'candidate-pro', query: _ctx.query },
        class: "block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition border-l-4 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50 focus:text-gray-800 focus:border-gray-300 focus:outline-none focus:bg-gray-50"
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_RouterLink, {
          to: { name: 'jobs', query: _ctx.query },
          class: "block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition border-l-4 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50 focus:text-gray-800 focus:border-gray-300 focus:outline-none focus:bg-gray-50",
          "active-class": "!text-gray-900"
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode(_component_RouterLink, {
        to: { name: 'profiles', query: _ctx.query },
        class: "block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition border-l-4 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50 focus:text-gray-800 focus:border-gray-300 focus:outline-none focus:bg-gray-50",
        "active-class": "!text-red-700 !border-red-500 !bg-red-50 !focus:text-red-800 !focus:bg-red-100 !focus:border-red-700 !focus:outline-none"
      }, {
        default: _withCtx(() => [
          _hoisted_30
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_RouterLink, {
        to: { name: 'services', query: _ctx.query },
        class: "block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition border-l-4 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50 focus:text-gray-800 focus:border-gray-300 focus:outline-none focus:bg-gray-50",
        "active-class": "!text-red-700 !border-red-500 !bg-red-50 !focus:text-red-800 !focus:bg-red-100 !focus:border-red-700 !focus:outline-none"
      }, {
        default: _withCtx(() => [
          _hoisted_31
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_32, [
        (!_ctx.loggedIn)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: { name: 'enter', query: _ctx.query },
              class: "block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition border-l-4 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50 focus:text-gray-800 focus:border-gray-300 focus:outline-none focus:bg-gray-50",
              "active-class": "!text-red-700 !border-red-500 !bg-red-50 !focus:text-red-800 !focus:bg-red-100 !focus:border-red-700 !focus:outline-none"
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 16))
}